import { OverlayTrigger, OverlayTriggerProps, Tooltip } from 'react-bootstrap';
import React, { ReactElement, ReactNode } from 'react';

export type PropsDeTooltip = Partial<OverlayTriggerProps> & {
    id?: string;
    texte: ReactNode;
    children: ReactElement;
    disabled?: boolean;
    inList?: boolean;
};

export default function TooltipSimple({
    id,
    texte,
    children,
    disabled,
    inList,
    ...rest
}: PropsDeTooltip): ReactElement {
    return disabled ? (
        children
    ) : (
        <OverlayTrigger
            {...rest}
            overlay={(props) => (
                <Tooltip id={id as string} {...props}>
                    {texte}
                </Tooltip>
            )}
        >
            {inList ? <div className="d-inline">{children}</div> : children}
        </OverlayTrigger>
    );
}

TooltipSimple.defaultProps = {
    id: 'tooltip-generique',
};
